export const HATCHED_PATTERN_ID = 'hatched-fill';
